// extracted by mini-css-extract-plugin
module.exports = {"emptySearchMessage":"emptyResult_emptySearchMessage__IcALv"};